import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import Popper from 'popper.js';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BooleanConverter, InputConverter, NumberConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var LatLongSelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LatLongSelectComponent, _super);
    function LatLongSelectComponent(_vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.latChange = new EventEmitter();
        _this.longChange = new EventEmitter();
        _this.latChangeSubject = new Subject();
        _this.longChangeSubject = new Subject();
        _this.debounceTime = 500;
        _this.outsideClickHandler = function () {
            _this.showLatLongSelect = false;
        };
        _this.insideClickHandler = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(LatLongSelectComponent.prototype, "showLatLongSelect", {
        get: function () { return this._showLatLongSelect; },
        set: function (value) {
            this._showLatLongSelect = value;
            this._showLatLongSelect ? this.onShow() : this.onHide();
        },
        enumerable: true,
        configurable: true
    });
    LatLongSelectComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.latLongSelectPopperRef = new Popper(this.latLongSelectToggleRef.nativeElement, this.latLongSelectContainerRef.nativeElement, {
            placement: 'bottom-end',
            positionFixed: true
        });
        this.latChangeSubject.pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe(function (lat) { return _this.latChange.emit(lat); });
        this.longChangeSubject.pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe(function (long) { return _this.longChange.emit(long); });
    };
    LatLongSelectComponent.prototype.onShow = function () {
        this.latLongSelectPopperRef.update();
        window.addEventListener('mousedown', this.outsideClickHandler);
        window.addEventListener('dragstart', this.outsideClickHandler);
        this.latLongSelectToggleRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
        this.latLongSelectContainerRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
    };
    LatLongSelectComponent.prototype.onHide = function () {
        window.removeEventListener('mousedown', this.outsideClickHandler);
        window.removeEventListener('dragstart', this.outsideClickHandler);
        this.latLongSelectToggleRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
        this.latLongSelectContainerRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
    };
    LatLongSelectComponent.prototype.onLatChange = function (lat) {
        this.lat = lat;
        this.latChangeSubject.next(lat);
    };
    LatLongSelectComponent.prototype.onLongChange = function (long) {
        this.long = long;
        this.longChangeSubject.next(long);
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], LatLongSelectComponent.prototype, "showLatLongSelect", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], LatLongSelectComponent.prototype, "lat", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], LatLongSelectComponent.prototype, "long", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], LatLongSelectComponent.prototype, "debounceTime", void 0);
    return LatLongSelectComponent;
}(BaseComponent));
export { LatLongSelectComponent };
